 import React from 'react' 
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'
import { ILocationModel } from './LocationModel'

type Props = {
  data: ILocationModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void  
  onEdit?: (branch: ILocationModel) => void  
  onDelete?: (branch: ILocationModel) => void  
  sortBy?: string  
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const LocationTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false
}) => {
  const locationColumns: TableColumn<ILocationModel>[] = [
    { key: 'name', label: 'Lokasyon Adı', className: 'fw-semibold' ,sortable: true},
    { key: 'displayOrder', label: 'Sıralama' },
  ]
 
  const locationActions: TableAction<ILocationModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (branch) => onEdit?.(branch),  
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (branch) => onDelete?.(branch),  
    },
  ]

  return (
    <DataTable
      data={data}
      columns={locationColumns}
      actions={locationActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz şube bulunamadı'
    />
  )
}